import React, { FunctionComponent, memo } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { Text } from "@/components/Text";
import { TextListWithDot } from "@/components/TextListWithDot";
import { getJobRequestClientInfo, IJobRequest } from "@/data/job-requests";
import { Flex } from "@/eworkitComponents";
import { JobRequestClientAvatar } from "@/views/JobRequests";

interface IJobRequestManagedBySectionProps {
  jobRequest: IJobRequest;
}

export const JobRequestManagedBySection: FunctionComponent<IJobRequestManagedBySectionProps> = memo(
  ({ jobRequest }) => {
    const { t } = useTranslation("session");

    const { administratorName, administratorVatNumber } = getJobRequestClientInfo(jobRequest);

    return (
      <Section padding={["lg"]} innerMargin="lg" flex borderRadius>
        <Flex direction="row" innerMargin="md">
          <Flex grow={1}>
            <JobRequestClientAvatar size="lg" jobRequest={jobRequest} administrator />
          </Flex>
          <Flex direction="column" innerMargin="md">
            <Flex direction="column" innerMargin="xs">
              <Header size="sm" weight="bold">
                {t("JOB_REQUESTS.DETAIL.MANAGED_BY", { name: administratorName })}
              </Header>
              <TextListWithDot>
                <Text key="vatNumber" color="black">
                  {administratorVatNumber}
                </Text>
                <Text key="website">{administratorName}</Text>
              </TextListWithDot>
            </Flex>
            <Text>{jobRequest.managedByDescription}</Text>
          </Flex>
        </Flex>
      </Section>
    );
  },
);
